export default __webpack_public_path__ + "static/media/link-enable-2.9882455e.svg";